import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { yupResolver } from "@hookform/resolvers/yup"
import { SubmitHandler, useForm } from "react-hook-form"
import { FormInput } from "@/shared/ui/form-input"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeCreateGroupModal, createGroupSchema, fetchCreateGroup, selectIsCreateGroupModalOpen, selectOnCreate, selectCurrentRole } from "../../model"
import { addGroup } from "@/entities/groups"

interface CreateGroupFormValues {
    name: string
}

const initialState: CreateGroupFormValues = {
    name: ""
}

export const CreateGroupModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsCreateGroupModalOpen)
    const onCreate = useAppSelector(selectOnCreate)
    const currentRole = useAppSelector(selectCurrentRole)

    const handleClose = () => {
        dispatch(closeCreateGroupModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchCreateGroup(data.name))
                .unwrap()
                .then((group) => {
                    dispatch(addGroup({ group, role: currentRole }))
                    notify.success('Группа успешно создана')
                    reset()
                    onCreate?.()
                    handleClose()
                    res('')
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(createGroupSchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title="Создание группы"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label={"Название"}
                    id={"name"}
                    error={errors['name']}
                    required={true}
                    placeholder="Введите название группы"
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button" type="button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Добавить
                    </button>
                </div>
            </form>
        </Modal>
    )
}